import { useGoogleLogin } from 'react-google-login';
import { useDispatch } from 'react-redux';

import { authActions } from '$store/auth';
import { toastActions } from '$store/toast';
import { getGoogleClientId } from '$utils';

export function useGoogleAuth() {
  const dispatch = useDispatch();

  const { signIn } = useGoogleLogin({
    clientId: getGoogleClientId(),
    onSuccess: (data) => {
      if ('tokenId' in data) {
        dispatch(authActions.googleAuth(data.tokenId));
      }
    },
    onFailure: (err) => {
      if (
        err.error !== undefined &&
        err.error !== 'popup_closed_by_user' &&
        err.error !== 'idpiframe_initialization_failed'
      ) {
        dispatch(toastActions.setToastFail(`${err.message || ''} (${err.error})`));
      }
    },
    redirectUri: location.protocol + '//' + location.host + '/google_auth',
    uxMode: 'redirect',
    prompt: 'select_account',
  });

  return signIn;
}
